import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Slideshow from '../components/slideshow'
import Instagram from '../components/instagram'
import Check from '../components/check'
import Quote from '../components/quote'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container10">
      <Helmet>
        <title>@Romania NGO</title>
        <meta
          name="description"
          content="Democratizing tourism by changing the way we plan, book and travel."
        />
        <meta property="og:title" content="@Romania NGO" />
        <meta
          property="og:description"
          content="Democratizing tourism by changing the way we plan, book and travel."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/262a7285-ee36-4827-90cf-bff2da51d3e3/e678668e-577d-45ce-9b60-b935d207ee1c?org_if_sml=1&amp;force_format=original"
        />
        <link
          rel="canonical"
          href="https://copy-of-romania-ngo-democratizing-tourism-via-web3-9ihr-naighba.vercel.app/"
        />
        <meta
          property="og:url"
          content="https://copy-of-romania-ngo-democratizing-tourism-via-web3-9ihr-naighba.vercel.app/"
        />
      </Helmet>
      <div className="home-thq-hero-elm1">
        <div className="home-thq-heading-elm10">
          <nav className="home-thq-navbar-elm">
            <div className="home-thq-desktop-elm">
              <Link to="/" className="home-navlink11">
                <div className="home-thq-main-elm10">
                  <div className="home-thq-branding-elm">
                    <img
                      alt="image"
                      src="/logo/romania_logo.svg"
                      className="home-image10"
                    />
                  </div>
                  <div className="home-thq-links-elm1">
                    <span className="home-thq-link-elm1 link">Features</span>
                    <span className="home-thq-link-elm2 link">
                      How it works
                    </span>
                    <span className="home-thq-link-elm3 link">Prices</span>
                    <span className="home-thq-link-elm4 link">Contact</span>
                  </div>
                </div>
              </Link>
              <Link to="/ambassadors" className="home-navlink12">
                <div className="home-thq-contribute-elm">
                  <span className="home-thq-sign-up-elm">Ambassadors</span>
                  <div className="home-container12">
                    <svg viewBox="0 0 1024 1024" className="home-icon10">
                      <path d="M512 950.857c-9.143 0-18.286-3.429-25.143-10.286l-356.571-344c-4.571-4-130.286-118.857-130.286-256 0-167.429 102.286-267.429 273.143-267.429 100 0 193.714 78.857 238.857 123.429 45.143-44.571 138.857-123.429 238.857-123.429 170.857 0 273.143 100 273.143 267.429 0 137.143-125.714 252-130.857 257.143l-356 342.857c-6.857 6.857-16 10.286-25.143 10.286z"></path>
                    </svg>
                  </div>
                </div>
              </Link>
              <img
                id="open-mobile-menu"
                alt="pastedImage"
                src="/pastedimage-8o98.svg"
                className="home-thq-hamburger-menu-elm"
              />
            </div>
            <div id="mobile-menu" className="home-thq-mobile-elm">
              <div className="home-thq-top-elm1">
                <img
                  alt="image"
                  src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
                  className="home-image11"
                />
                <svg
                  id="close-mobile-menu"
                  viewBox="0 0 1024 1024"
                  className="home-icon12"
                >
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </div>
              <div className="home-thq-links-elm2">
                <Link to="/" className="home-navlink13">
                  Features
                </Link>
                <Link to="/" className="home-navlink14">
                  How it works
                </Link>
                <Link to="/" className="home-navlink15">
                  Prices
                </Link>
                <Link to="/" className="home-navlink16">
                  Contact
                </Link>
                <div className="home-thq-buttons-elm1">
                  <Link to="/" className="home-navlink17">
                    <div className="home-thq-btn-elm1">
                      <span className="home-text100">Log in</span>
                    </div>
                  </Link>
                  <Link to="/" className="home-navlink18">
                    <div className="home-thq-btn-elm2">
                      <span className="home-text101">Sign up</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div>
              <div className="home-container14">
                <Script
                  html={`<script>
(function() {
  var mobileMenu = document.querySelector("#mobile-menu");
  var closeButton = document.querySelector("#close-mobile-menu");
  var openButton = document.querySelector("#open-mobile-menu");
  if (mobileMenu && closeButton && openButton) {
    openButton.addEventListener("click", function() {
      mobileMenu.style.transform = "translateX(0%)";
    });
    closeButton.addEventListener("click", function() {
      mobileMenu.style.transform = "translateX(100%)";
    });
  }
})();
</script>`}
                ></Script>
              </div>
            </div>
          </nav>
        </div>
        <div className="home-thq-hero-elm2">
          <div className="home-thq-content-elm1">
            <div className="home-container15">
              <h1 className="home-thq-title-elm12">
                <span>Democratizing tourism</span>
                <br></br>
                <span>by changing</span>
                <br></br>
                <span>the way we</span>
                <br></br>
              </h1>
              <div className="home-container16">
                <div className="home-container17">
                  <div className="home-thq-plan-elm1">
                    <h1 className="home-thq-title-elm13">
                      <span>plan,</span>
                      <br></br>
                    </h1>
                    <img
                      alt="image"
                      src="/blue.svg"
                      className="home-thq-red-elm"
                    />
                  </div>
                  <div className="home-thq-book-elm">
                    <h1 className="home-thq-title-elm14">
                      <span>book</span>
                      <br></br>
                    </h1>
                    <img
                      alt="image"
                      src="/yellow.svg"
                      className="home-image12"
                    />
                  </div>
                </div>
                <div className="home-thq-travel-elm">
                  <h1 className="home-thq-title-elm15">
                    <span>and travel</span>
                    <br></br>
                  </h1>
                  <img alt="image" src="/red.svg" className="home-image13" />
                </div>
              </div>
            </div>
            <span className="home-thq-caption-elm10">
              Take control of your travel experiences and help shape
              Romania&apos;s tourism promotion. Whether you&apos;re a traveler,
              a business owner or just someone who wants to create a positive
              impact, find out how we&apos;re changing the tourism game in
              Romania by building a powerful Country Brand and how you can help
              us achieve it.
            </span>
            <div className="home-thq-buttons-elm2">
              <div className="home-thq-ropass-elm1">
                <a
                  href="https://romaniapass.io/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="home-link10"
                >
                  <div className="home-thq-ro-passs-button-elm">
                    <img
                      alt="image"
                      src="/buttons/ropass_3.svg"
                      className="home-thq-ropass-elm2"
                    />
                  </div>
                </a>
              </div>
              <div className="home-thq-stramosi-elm1">
                <a
                  href="https://www.stramosi.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="home-link11"
                >
                  <div className="home-thq-stramosi-elm2">
                    <img
                      alt="image"
                      src="/buttons/stramosi_button.svg"
                      className="home-thq-stramosi-elm3"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <img alt="image" src="/map.svg" className="home-thq-map-elm1" />
        <img
          alt="image"
          src="/compressed-3500w.gif"
          className="home-thq-gif-elm"
        />
      </div>
      <div className="home-thq-stats-elm">
        <div className="home-thq-stat-elm1">
          <img alt="image" src="/1.svg" className="home-image14" />
          <span className="home-thq-caption-elm11">
            <span>6M+ </span>
            <span>followers</span>
          </span>
          <span className="home-thq-description-elm10">
            On Social Media
          </span>
        </div>
        <div className="home-thq-stat-elm2">
          <img alt="image" src="/2.svg" className="home-image15" />
          <span className="home-thq-caption-elm12">
            <span>6B+ </span>
            <span>views</span>
          </span>
          <span className="home-thq-description-elm11">
            Generated so far
          </span>
        </div>
        <div className="home-thq-stat-elm3">
          <img alt="image" src="/3.svg" className="home-image16" />
          <span className="home-thq-caption-elm13">
            <span>2B+ </span>
            <span>unique</span>
          </span>
          <span className="home-thq-description-elm12">
            People reached in 1 year
          </span>
        </div>
        <div className="home-thq-stat-elm4">
          <img alt="image" src="/earth2.svg" className="home-image17" />
          <span className="home-thq-caption-elm14">
            <span>1/4th </span>
            <span>population</span>
          </span>
          <span className="home-thq-description-elm13">
            Of the Planet reached
          </span>
        </div>
      </div>
      <section className="home-thq-schedule-elm">
        <div className="home-thq-content-elm2">
          <div className="home-thq-header-elm1">
            <div className="home-thq-section-numeral-elm">
              <div className="home-thq-divide-elm"></div>
              <p className="home-text122">02</p>
            </div>
            <div data-aos="fade-right" className="home-thq-heading-elm11">
              <h2 className="home-thq-title-elm16">Schedule</h2>
              <p className="home-thq-caption-elm15">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam.
              </p>
            </div>
          </div>
          <div className="home-thq-main-elm11">
            <div className="home-thq-tab-selector-elm">
              <div
                data-role="schedule-select"
                className="tab-active tab home-thq-tab-elm1"
              >
                <span className="home-text123">Friday, Nov 04</span>
              </div>
              <div
                data-role="schedule-select"
                className="tab home-thq-tab-elm2"
              >
                <span className="home-text124">Saturday, Nov 05</span>
              </div>
              <div
                data-role="schedule-select"
                className="tab home-thq-tab-elm3"
              >
                <span className="home-text125">Sunday, Nov 06</span>
              </div>
            </div>
            <div className="home-thq-lists-elm">
              <section
                data-role="schedule-content"
                className="home-thq-list-elm1"
              >
                <div className="home-thq-element-elm10">
                  <div className="home-thq-main-elm12">
                    <span className="home-thq-time-elm10">
                      8:00 AM - 2:00 PM GMT +1 / 10:00 AM - 4:00 PM Your local
                      time (6 Hours)
                    </span>
                    <h3 className="home-thq-title-elm17">
                      Pre-event networking
                    </h3>
                    <div className="home-thq-author-elm10">
                      <img
                        alt="image"
                        src="https://images.unsplash.com/photo-1607957159143-de3859adca2d?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIwfHxwb3RyYWl0fGVufDB8fHx8MTY3MTE5ODQwMQ&amp;ixlib=rb-4.0.3&amp;w=200"
                        className="home-thq-icon-elm10"
                      />
                      <div className="home-thq-details-elm10">
                        <span className="home-thq-name-elm10">Andy Smith</span>
                        <div className="home-thq-point-elm10"></div>
                        <span className="home-thq-caption-elm16">
                          CEO, Opary
                        </span>
                      </div>
                    </div>
                  </div>
                  <button className="button home-button10">
                    Connect to chat room
                  </button>
                </div>
                <div className="home-thq-element-elm11">
                  <div className="home-thq-main-elm13">
                    <span className="home-thq-time-elm11">
                      3:00 PM - 3:30 PM GMT +1 / 5:00 PM - 5:30 PM Your local
                      time (30 Minutes)
                    </span>
                    <h3 className="home-thq-title-elm18">
                      How to Lorem Ipsum.
                    </h3>
                    <div className="home-thq-author-elm11">
                      <img
                        alt="image"
                        src="https://images.unsplash.com/photo-1607957159143-de3859adca2d?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIwfHxwb3RyYWl0fGVufDB8fHx8MTY3MTE5ODQwMQ&amp;ixlib=rb-4.0.3&amp;w=200"
                        className="home-thq-icon-elm11"
                      />
                      <div className="home-thq-details-elm11">
                        <span className="home-thq-name-elm11">
                          Samantha Johnson
                        </span>
                        <div className="home-thq-point-elm11"></div>
                        <span className="home-thq-caption-elm17">
                          CEO, Opary
                        </span>
                      </div>
                    </div>
                  </div>
                  <button className="button home-button11">
                    <span>
                      <span>See live</span>
                      <br></br>
                    </span>
                  </button>
                </div>
                <div className="home-thq-element-elm12">
                  <div className="home-thq-main-elm14">
                    <span className="home-thq-time-elm12">
                      3:00 PM - 3:30 PM GMT +1 / 5:00 PM - 5:30 PM Your local
                      time (30 Minutes)
                    </span>
                    <h3 className="home-thq-title-elm19">
                      How to Lorem Ipsum.
                    </h3>
                    <div className="home-thq-author-elm12">
                      <img
                        alt="image"
                        src="https://images.unsplash.com/photo-1607957159143-de3859adca2d?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIwfHxwb3RyYWl0fGVufDB8fHx8MTY3MTE5ODQwMQ&amp;ixlib=rb-4.0.3&amp;w=200"
                        className="home-thq-icon-elm12"
                      />
                      <div className="home-thq-details-elm12">
                        <span className="home-thq-name-elm12">
                          Samantha Johnson
                        </span>
                        <div className="home-thq-point-elm12"></div>
                        <span className="home-thq-caption-elm18">
                          CEO, Opary
                        </span>
                      </div>
                    </div>
                  </div>
                  <button className="button home-button12">
                    <span>
                      <span>See live</span>
                      <br></br>
                    </span>
                  </button>
                </div>
                <div className="home-thq-element-elm13">
                  <div className="home-thq-main-elm15">
                    <span className="home-thq-time-elm13">
                      3:00 PM - 3:30 PM GMT +1 / 5:00 PM - 5:30 PM Your local
                      time (30 Minutes)
                    </span>
                    <h3 className="home-thq-title-elm20">
                      How to Lorem Ipsum.
                    </h3>
                    <div className="home-thq-author-elm13">
                      <img
                        alt="image"
                        src="https://images.unsplash.com/photo-1607957159143-de3859adca2d?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIwfHxwb3RyYWl0fGVufDB8fHx8MTY3MTE5ODQwMQ&amp;ixlib=rb-4.0.3&amp;w=200"
                        className="home-thq-icon-elm13"
                      />
                      <div className="home-thq-details-elm13">
                        <span className="home-thq-name-elm13">
                          Samantha Johnson
                        </span>
                        <div className="home-thq-point-elm13"></div>
                        <span className="home-thq-caption-elm19">
                          CEO, Opary
                        </span>
                      </div>
                    </div>
                  </div>
                  <button className="button home-button13">
                    <span>
                      <span>See live</span>
                      <br></br>
                    </span>
                  </button>
                </div>
                <div className="home-thq-element-elm14">
                  <div className="home-thq-main-elm16">
                    <span className="home-thq-time-elm14">
                      3:00 PM - 3:30 PM GMT +1 / 5:00 PM - 5:30 PM Your local
                      time (30 Minutes)
                    </span>
                    <h3 className="home-thq-title-elm21">
                      How to Lorem Ipsum.
                    </h3>
                    <div className="home-thq-author-elm14">
                      <img
                        alt="image"
                        src="https://images.unsplash.com/photo-1607957159143-de3859adca2d?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIwfHxwb3RyYWl0fGVufDB8fHx8MTY3MTE5ODQwMQ&amp;ixlib=rb-4.0.3&amp;w=200"
                        className="home-thq-icon-elm14"
                      />
                      <div className="home-thq-details-elm14">
                        <span className="home-thq-name-elm14">
                          Samantha Johnson
                        </span>
                        <div className="home-thq-point-elm14"></div>
                        <span className="home-thq-caption-elm20">
                          CEO, Opary
                        </span>
                      </div>
                    </div>
                  </div>
                  <button className="button home-button14">
                    <span>
                      <span>See live</span>
                      <br></br>
                    </span>
                  </button>
                </div>
                <div className="home-thq-element-elm15">
                  <div className="home-thq-main-elm17">
                    <span className="home-thq-time-elm15">
                      8:00 PM - 10:00 PM GMT +1 / 10:00 PM - 12:00 AM Your local
                      time (2 Hours)
                    </span>
                    <h3 className="home-thq-title-elm22">
                      Post-event networking
                    </h3>
                    <div className="home-thq-author-elm15">
                      <img
                        alt="image"
                        src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDZ8fHBvdHJhaXR8ZW58MHx8fHwxNjcxNDg1OTU2&amp;ixlib=rb-4.0.3&amp;w=200"
                        className="home-thq-icon-elm15"
                      />
                      <div className="home-thq-details-elm15">
                        <span className="home-thq-name-elm15">
                          Samantha Johnson
                        </span>
                        <div className="home-thq-point-elm15"></div>
                        <span className="home-thq-caption-elm21">
                          CEO, Opary
                        </span>
                      </div>
                    </div>
                  </div>
                  <button className="button home-button15">
                    <span>
                      <span>Connect to chat room</span>
                      <br></br>
                    </span>
                  </button>
                </div>
              </section>
              <section
                data-role="schedule-content"
                className="home-thq-list-elm2"
              >
                <div className="home-thq-element-elm16">
                  <div className="home-thq-main-elm18">
                    <span className="home-thq-time-elm16">
                      3:00 PM - 3:30 PM GMT +1 / 5:00 PM - 5:30 PM Your local
                      time (30 Minutes)
                    </span>
                    <h3 className="home-thq-title-elm23">
                      How to Lorem Ipsum.
                    </h3>
                    <div className="home-thq-author-elm16">
                      <img
                        alt="image"
                        src="https://images.unsplash.com/photo-1607957159143-de3859adca2d?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIwfHxwb3RyYWl0fGVufDB8fHx8MTY3MTE5ODQwMQ&amp;ixlib=rb-4.0.3&amp;w=200"
                        className="home-thq-icon-elm16"
                      />
                      <div className="home-thq-details-elm16">
                        <span className="home-thq-name-elm16">
                          Samantha Johnson
                        </span>
                        <div className="home-thq-point-elm16"></div>
                        <span className="home-thq-caption-elm22">
                          CEO, Opary
                        </span>
                      </div>
                    </div>
                  </div>
                  <button className="button home-button16">
                    <span>
                      <span>See live</span>
                      <br></br>
                    </span>
                  </button>
                </div>
                <div className="home-thq-element-elm17">
                  <div className="home-thq-main-elm19">
                    <span className="home-thq-time-elm17">
                      8:00 AM - 2:00 PM GMT +1 / 10:00 AM - 4:00 PM Your local
                      time (6 Hours)
                    </span>
                    <h3 className="home-thq-title-elm24">
                      Pre-event networking
                    </h3>
                    <div className="home-thq-author-elm17">
                      <img
                        alt="image"
                        src="https://images.unsplash.com/photo-1607957159143-de3859adca2d?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIwfHxwb3RyYWl0fGVufDB8fHx8MTY3MTE5ODQwMQ&amp;ixlib=rb-4.0.3&amp;w=200"
                        className="home-thq-icon-elm17"
                      />
                      <div className="home-thq-details-elm17">
                        <span className="home-thq-name-elm17">Andy Smith</span>
                        <div className="home-thq-point-elm17"></div>
                        <span className="home-thq-caption-elm23">
                          CEO, Opary
                        </span>
                      </div>
                    </div>
                  </div>
                  <button className="button home-button17">
                    Connect to chat room
                  </button>
                </div>
                <div className="home-thq-element-elm18">
                  <div className="home-thq-main-elm20">
                    <span className="home-thq-time-elm18">
                      3:00 PM - 3:30 PM GMT +1 / 5:00 PM - 5:30 PM Your local
                      time (30 Minutes)
                    </span>
                    <h3 className="home-thq-title-elm25">
                      How to Lorem Ipsum.
                    </h3>
                    <div className="home-thq-author-elm18">
                      <img
                        alt="image"
                        src="https://images.unsplash.com/photo-1607957159143-de3859adca2d?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIwfHxwb3RyYWl0fGVufDB8fHx8MTY3MTE5ODQwMQ&amp;ixlib=rb-4.0.3&amp;w=200"
                        className="home-thq-icon-elm18"
                      />
                      <div className="home-thq-details-elm18">
                        <span className="home-thq-name-elm18">
                          Samantha Johnson
                        </span>
                        <div className="home-thq-point-elm18"></div>
                        <span className="home-thq-caption-elm24">
                          CEO, Opary
                        </span>
                      </div>
                    </div>
                  </div>
                  <button className="button home-button18">
                    <span>
                      <span>See live</span>
                      <br></br>
                    </span>
                  </button>
                </div>
              </section>
              <section
                data-role="schedule-content"
                className="home-thq-list-elm3"
              >
                <div className="home-thq-element-elm19">
                  <div className="home-thq-main-elm21">
                    <span className="home-thq-time-elm19">
                      8:00 AM - 2:00 PM GMT +1 / 10:00 AM - 4:00 PM Your local
                      time (6 Hours)
                    </span>
                    <h3 className="home-thq-title-elm26">
                      Pre-event networking
                    </h3>
                    <div className="home-thq-author-elm19">
                      <img
                        alt="image"
                        src="https://images.unsplash.com/photo-1607957159143-de3859adca2d?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIwfHxwb3RyYWl0fGVufDB8fHx8MTY3MTE5ODQwMQ&amp;ixlib=rb-4.0.3&amp;w=200"
                        className="home-thq-icon-elm19"
                      />
                      <div className="home-thq-details-elm19">
                        <span className="home-thq-name-elm19">Andy Smith</span>
                        <div className="home-thq-point-elm19"></div>
                        <span className="home-thq-caption-elm25">
                          CEO, Opary
                        </span>
                      </div>
                    </div>
                  </div>
                  <button className="button home-button19">
                    Connect to chat room
                  </button>
                </div>
                <div className="home-thq-element-elm20">
                  <div className="home-thq-main-elm22">
                    <span className="home-thq-time-elm20">
                      3:00 PM - 3:30 PM GMT +1 / 5:00 PM - 5:30 PM Your local
                      time (30 Minutes)
                    </span>
                    <h3 className="home-thq-title-elm27">
                      How to Lorem Ipsum.
                    </h3>
                    <div className="home-thq-author-elm20">
                      <img
                        alt="image"
                        src="https://images.unsplash.com/photo-1607957159143-de3859adca2d?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIwfHxwb3RyYWl0fGVufDB8fHx8MTY3MTE5ODQwMQ&amp;ixlib=rb-4.0.3&amp;w=200"
                        className="home-thq-icon-elm20"
                      />
                      <div className="home-thq-details-elm20">
                        <span className="home-thq-name-elm20">
                          Samantha Johnson
                        </span>
                        <div className="home-thq-point-elm20"></div>
                        <span className="home-thq-caption-elm26">
                          CEO, Opary
                        </span>
                      </div>
                    </div>
                  </div>
                  <button className="button home-button20">
                    <span>
                      <span>See live</span>
                      <br></br>
                    </span>
                  </button>
                </div>
                <div className="home-thq-element-elm21">
                  <div className="home-thq-main-elm23">
                    <span className="home-thq-time-elm21">
                      3:00 PM - 3:30 PM GMT +1 / 5:00 PM - 5:30 PM Your local
                      time (30 Minutes)
                    </span>
                    <h3 className="home-thq-title-elm28">
                      How to Lorem Ipsum.
                    </h3>
                    <div className="home-thq-author-elm21">
                      <img
                        alt="image"
                        src="https://images.unsplash.com/photo-1607957159143-de3859adca2d?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIwfHxwb3RyYWl0fGVufDB8fHx8MTY3MTE5ODQwMQ&amp;ixlib=rb-4.0.3&amp;w=200"
                        className="home-thq-icon-elm21"
                      />
                      <div className="home-thq-details-elm21">
                        <span className="home-thq-name-elm21">
                          Samantha Johnson
                        </span>
                        <div className="home-thq-point-elm21"></div>
                        <span className="home-thq-caption-elm27">
                          CEO, Opary
                        </span>
                      </div>
                    </div>
                  </div>
                  <button className="button home-button21">
                    <span>
                      <span>See live</span>
                      <br></br>
                    </span>
                  </button>
                </div>
                <div className="home-thq-element-elm22">
                  <div className="home-thq-main-elm24">
                    <span className="home-thq-time-elm22">
                      8:00 PM - 10:00 PM GMT +1 / 10:00 PM - 12:00 AM Your local
                      time (2 Hours)
                    </span>
                    <h3 className="home-thq-title-elm29">
                      Post-event networking
                    </h3>
                    <div className="home-thq-author-elm22">
                      <img
                        alt="image"
                        src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDZ8fHBvdHJhaXR8ZW58MHx8fHwxNjcxNDg1OTU2&amp;ixlib=rb-4.0.3&amp;w=200"
                        className="home-thq-icon-elm22"
                      />
                      <div className="home-thq-details-elm22">
                        <span className="home-thq-name-elm22">
                          Samantha Johnson
                        </span>
                        <div className="home-thq-point-elm22"></div>
                        <span className="home-thq-caption-elm28">
                          CEO, Opary
                        </span>
                      </div>
                    </div>
                  </div>
                  <button className="button home-button22">
                    <span>
                      <span>Connect to chat room</span>
                      <br></br>
                    </span>
                  </button>
                </div>
              </section>
            </div>
            <div>
              <div className="home-container19">
                <Script
                  html={`<script>
(function() {
  var tabButtons = document.querySelectorAll('[data-role="schedule-select"]');
  var tabContents = document.querySelectorAll('[data-role="schedule-content"]');
  if (tabButtons.length && tabContents.length) {
    tabButtons[0].classList.add("tab-active");
    tabContents[0].style.display = "block";
    tabButtons.forEach(function(tabButton, index) {
      tabButton.addEventListener("click", function() {
        tabButtons.forEach(function(button) {
          button.classList.remove("tab-active");
        });
        tabButton.classList.add("tab-active");
        tabContents.forEach(function(tabContent) {
          tabContent.style.display = "none";
        });
        tabContents[index].style.display = "block";
      });
    });
  }
})();
</script>`}
                ></Script>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="home-thq-sections-elm">
        <div id="@Romania" className="home-thq-section-elm1">
          <div className="home-container20">
            <Slideshow rootClassName="slideshowroot-class-name"></Slideshow>
          </div>
          <div className="home-thq-content-elm3">
            <h2 className="home-text156">What is @Romania?</h2>
            <div className="home-thq-highlight-elm1">
              <span className="home-text157">
                The NGO that&apos;s moving fast and breaking things in order to
                put Romania back on the map.
              </span>
              <span className="home-text158">
                We’re empowering travelers, local communities and tourism
                businesses to take control of their experiences and
                interactions. With over 6 million followers on social media and
                more than 90 million people reached every month, @Romania is
                probably the most influential tourism brand in the country and
                we’re just getting started. Our strategy is to bring a new level
                of community-driven and business-integrated promotion for
                Romania’s tourism.
              </span>
            </div>
            <Link to="/ambassadors" className="home-navlink19">
              <div className="home-thq-explore-elm1">
                <span>
                  <span>More on this </span>
                  <span className="home-text161">here</span>
                  <span className="home-text162"> -&gt;</span>
                </span>
              </div>
            </Link>
          </div>
        </div>
        <div className="home-thq-section-elm2">
          <div className="home-container21">
            <div className="home-container22">
              <h2 className="home-text163">
                <span>More than 6 million people</span>
                <br></br>
                <span>follow @Romania</span>
              </h2>
            </div>
            <div className="home-container23">
              <Instagram
                imageSrc="/socials/1a-1500w.jpg"
                imageSrc1="/socials/11-1500w.jpg"
                imageSrc2="/socials/1a-1500w.jpg"
                imageSrc11="/socials/11-1500w.jpg"
                outlineSrc="/socials/ig.svg"
                rootClassName="instagramroot-class-name"
              ></Instagram>
              <Instagram
                text="@Romania on Facebook"
                text1="Share Deeply Rooted Values"
                text2="Follow @Romania on Facebook to share in the country's rich history, traditions, stories and even legends"
                imageSrc="/socials/2a-1500w.jpg"
                linkIcon="https://www.facebook.com/romania/"
                imageSrc1="/socials/21-1500w.jpg"
                imageSrc2="/socials/2a-1500w.jpg"
                imageSrc11="/socials/21-1500w.jpg"
                outlineSrc="/socials/fb.svg"
                linkOutline="https://www.facebook.com/romania/"
              ></Instagram>
              <Instagram
                text="@Romania on TikTok"
                text1="Experience Romania's Magic"
                text2="Discover hidden gems, a vibrant culture, and breathtaking scenery on @Romania's TikTok account"
                imageSrc="/socials/31-1500w.jpg"
                linkIcon="https://www.tiktok.com/@romania"
                imageSrc1="/socials/3a-1500w.jpg"
                imageSrc2="/socials/31-1500w.jpg"
                imageSrc11="/socials/3a-1500w.jpg"
                outlineSrc="/socials/tiktok.svg"
                linkOutline="https://www.tiktok.com/@romania"
              ></Instagram>
              <Instagram
                text="@Romania on LinkedIn"
                text1="Connect With Like-Minded People"
                text2="Join @Romania's LinkedIn community to connect with professionals, share ideas and be part of a movement that is shaping the future of tourism."
                imageSrc="/socials/7-1500w.png"
                linkIcon="https://www.linkedin.com/company/romania/"
                imageSrc1="/socials/1b-1500w.jpg"
                imageSrc2="/socials/7-1500w.png"
                imageSrc11="/socials/1b-1500w.jpg"
                outlineSrc="/socials/linkedin.svg"
                linkOutline="https://www.linkedin.com/company/romania/"
              ></Instagram>
            </div>
          </div>
        </div>
        <div id="About" className="home-thq-section-elm3">
          <div className="home-thq-steps-elm">
            <div className="home-thq-map-elm2">
              <a
                href="https://www.instagram.com/bucuresti/"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link12"
              >
                <div className="home-thq-bucuresti-elm1">
                  <span className="home-text167">Bucuresti</span>
                  <div className="home-thq-bucuresti-elm2">
                    <div className="home-container24"></div>
                  </div>
                </div>
              </a>
              <a
                href="https://www.instagram.com/craiova/"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link13"
              >
                <div className="home-thq-craiova-elm1">
                  <span className="home-text168">Craiova</span>
                  <div className="home-thq-craiova-elm2">
                    <div className="home-container25"></div>
                  </div>
                </div>
              </a>
              <a
                href="https://www.instagram.com/timisoara/"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link14"
              >
                <div className="home-thq-timisoara-elm1">
                  <span className="home-text169">Timisoara</span>
                  <div className="home-thq-timisoara-elm2">
                    <div className="home-container26"></div>
                  </div>
                </div>
              </a>
              <a
                href="https://www.instagram.com/oradea/"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link15"
              >
                <div className="home-thq-oradea-elm1">
                  <span className="home-text170">Oradea</span>
                  <div className="home-thq-oradea-elm2">
                    <div className="home-container27"></div>
                  </div>
                </div>
              </a>
              <a
                href="https://www.instagram.com/cluj/"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link16"
              >
                <div className="home-thq-cluj-napoca-elm1">
                  <span className="home-text171">Cluj-Napoca</span>
                  <div className="home-thq-cluj-napoca-elm2">
                    <div className="home-container28"></div>
                  </div>
                </div>
              </a>
              <a
                href="https://www.instagram.com/albaiulia/"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link17"
              >
                <div className="home-thq-alba-iulia-elm1">
                  <span className="home-text172">Alba Iulia</span>
                  <div className="home-thq-alba-iulia-elm2">
                    <div className="home-container29"></div>
                  </div>
                </div>
              </a>
              <a
                href="https://www.instagram.com/sighisoara/"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link18"
              >
                <div className="home-thq-sighisoara-elm1">
                  <span className="home-text173">Sighisoara</span>
                  <div className="home-thq-sighisoara-elm2">
                    <div className="home-container30"></div>
                  </div>
                </div>
              </a>
              <a
                href="https://www.instagram.com/constanta/"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link19"
              >
                <div className="home-thq-constanta-elm1">
                  <span className="home-text174">Constanta</span>
                  <div className="home-thq-constanta-elm2">
                    <div className="home-container31"></div>
                  </div>
                </div>
              </a>
              <a
                href="https://www.instagram.com/sibiu/"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link20"
              >
                <div className="home-thq-sibiu-elm1">
                  <span className="home-text175">Sibiu</span>
                  <div className="home-thq-sibiu-elm2">
                    <div className="home-container32"></div>
                  </div>
                </div>
              </a>
              <a
                href="https://www.instagram.com/brasov/"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link21"
              >
                <div className="home-thq-brasov-elm1">
                  <span className="home-text176">Brasov</span>
                  <div className="home-thq-brasov-elm2">
                    <div className="home-container33"></div>
                  </div>
                </div>
              </a>
            </div>
            <div className="home-thq-content-elm4">
              <h2 className="home-text177">What&apos;s our plan?</h2>
              <div className="home-thq-highlight-elm2">
                <span className="home-text178">First things first</span>
                <span className="home-text179">
                  <span>
                    We are creating a catalyst for progress in the form of a
                    powerful Country Brand for Romania and promoting it across
                    major social media platforms, to millions of people.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    For this to happen, we’ve developed the Ambassador Program
                    where you and everyone interested in advancing Romania’s
                    tourism promotion and boosting its economy can help achieve
                    it.
                  </span>
                </span>
              </div>
              <div className="home-thq-highlight-elm3">
                <span className="home-text184">Moving forward</span>
                <span className="home-text185">
                  <span>
                    @Romania is taking a smart approach to tourism promotion. By
                    democratizing tourism through innovative technology and
                    high-impact community engagement, we are making it easier
                    for travelers to discover Romania’s offerings and for
                    businesses in Romania to thrive.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    Our game plan is effective and cost-efficient. With a
                    limited budget, @Romania is already achieving incredible
                    results, showcasing our country to a massive international
                    audience as a place worth visiting. The next step is to
                    build the necessary components that will help secure
                    Romania’s place on the global stage.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </span>
              </div>
              <a
                href="https://www.romania.org.ro/ambassadors#stats"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link22"
              >
                <div className="home-thq-explore-elm2">
                  <span>
                    <span>More on this </span>
                    <span className="home-text192">here</span>
                    <span className="home-text193"> -&gt;</span>
                  </span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="home-thq-banner-container-elm">
        <div className="home-thq-banner-elm">
          <div className="home-thq-overlay-elm1">
            <div className="home-container34">
              <span className="home-text194">
                Explore the Carpathian Garden
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="home-text195">
                Building a powerful Country Brand
              </span>
            </div>
            <a
              href="https://www.romania.org.ro/ambassadors#brand"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link23 button"
            >
              <span className="home-text196">Learn more</span>
              <span className="home-text197">-&gt;</span>
            </a>
          </div>
        </div>
      </div>
      <div className="home-thq-pricing-elm">
        <div className="home-thq-content-elm5">
          <div className="home-thq-header-elm2">
            <div className="home-thq-tag-elm1">
              <span className="home-text198">Pricing plans</span>
            </div>
            <div className="home-thq-heading-elm12">
              <h2 className="home-text199">No setup cost or hidden fees.</h2>
            </div>
          </div>
          <div className="home-thq-pricing-plans-elm">
            <div className="home-thq-plans-elm1">
              <div className="home-thq-plan-elm2">
                <div className="home-thq-top-elm2">
                  <div className="home-thq-heading-elm13">
                    <span className="home-text200">Standard</span>
                    <span className="home-text201">
                      Sed ut perspiciatis unde omnis iste natus error sit.
                    </span>
                  </div>
                  <div className="home-thq-cost-elm1">
                    <span className="home-thq-text-elm10">Free</span>
                  </div>
                </div>
                <div className="home-thq-bottom-elm1">
                  <div className="home-thq-check-list-elm1">
                    <Check></Check>
                    <Check feature="Quis nostrud exercitation ulla"></Check>
                    <Check feature="Duis aute irure dolor intuit"></Check>
                    <Check feature="Voluptas sit aspernatur aut odit"></Check>
                    <Check feature="Corporis suscipit laboriosam"></Check>
                  </div>
                  <div className="home-thq-button-elm2">
                    <span className="home-thq-text-elm11">Get Standard</span>
                  </div>
                </div>
              </div>
              <div className="home-thq-plan-elm3">
                <div className="home-thq-top-elm3">
                  <div className="home-thq-heading-elm14">
                    <span className="home-text202">Plus</span>
                    <span className="home-text203">
                      Sed ut perspiciatis unde omnis iste natus error sit.
                    </span>
                  </div>
                  <div className="home-thq-cost-elm2">
                    <span className="home-thq-text-elm12">$8</span>
                    <span className="home-thq-text-elm13">/month</span>
                  </div>
                </div>
                <div className="home-thq-bottom-elm2">
                  <div className="home-thq-check-list-elm2">
                    <Check></Check>
                    <Check feature="Quis nostrud exercitation ulla"></Check>
                    <Check feature="Duis aute irure dolor intuit"></Check>
                    <Check feature="Voluptas sit aspernatur aut odit"></Check>
                    <Check feature="Corporis suscipit laboriosam"></Check>
                  </div>
                  <div className="home-thq-button-elm3">
                    <span className="home-thq-text-elm14">Get Standard</span>
                  </div>
                </div>
              </div>
              <div className="home-thq-plan-elm4">
                <div className="home-thq-top-elm4">
                  <div className="home-thq-heading-elm15">
                    <span className="home-text204">Premium</span>
                    <span className="home-text205">
                      Sed ut perspiciatis unde omnis iste natus error sit.
                    </span>
                  </div>
                  <div className="home-thq-cost-elm3">
                    <span className="home-thq-text-elm15">$16</span>
                    <span className="home-thq-text-elm16">/month</span>
                  </div>
                </div>
                <div className="home-thq-bottom-elm3">
                  <div className="home-thq-check-list-elm3">
                    <Check></Check>
                    <Check feature="Quis nostrud exercitation ulla"></Check>
                    <Check feature="Duis aute irure dolor intuit"></Check>
                    <Check feature="Voluptas sit aspernatur aut odit"></Check>
                    <Check feature="Corporis suscipit laboriosam"></Check>
                  </div>
                  <div className="home-thq-button-elm4">
                    <span className="home-thq-text-elm17">Get Standard</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="home-thq-expand-elm1">
              <div className="home-thq-overlay-elm2">
                <div className="home-thq-header-elm3">
                  <div className="home-thq-heading-elm16">
                    <span className="home-text206">Expand</span>
                    <span className="home-text207">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt.
                    </span>
                  </div>
                  <div className="home-thq-check-list-elm4">
                    <div className="home-thq-check-elm1">
                      <svg viewBox="0 0 1024 1024" className="home-icon14">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span className="home-text208">
                        Sed ut perspiciatis unde
                      </span>
                    </div>
                    <div className="home-thq-check-elm2">
                      <svg viewBox="0 0 1024 1024" className="home-icon16">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span className="home-text209">
                        Quis nostrud exercitation ulla
                      </span>
                    </div>
                    <div className="home-thq-check-elm3">
                      <svg viewBox="0 0 1024 1024" className="home-icon18">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span className="home-text210">
                        Duis aute irure dolor intuit
                      </span>
                    </div>
                  </div>
                </div>
                <div className="home-thq-button-elm5">
                  <span className="home-thq-text-elm18">
                    <span>Contact us</span>
                    <br></br>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="home-thq-plans-elm2">
            <div className="home-thq-plan-elm5">
              <div className="home-thq-top-elm5">
                <div className="home-thq-heading-elm17">
                  <span className="home-text213">Standard</span>
                  <span className="home-text214">
                    Sed ut perspiciatis unde omnis iste natus error sit.
                  </span>
                </div>
                <div className="home-thq-cost-elm4">
                  <span className="home-thq-text-elm19">Free</span>
                </div>
              </div>
              <div className="home-thq-bottom-elm4">
                <div className="home-thq-check-list-elm5">
                  <Check></Check>
                  <Check feature="Quis nostrud exercitation ulla"></Check>
                  <Check feature="Duis aute irure dolor intuit"></Check>
                  <Check feature="Voluptas sit aspernatur aut odit"></Check>
                  <Check feature="Corporis suscipit laboriosam"></Check>
                </div>
                <div className="home-thq-button-elm6">
                  <span className="home-thq-text-elm20">Get Standard</span>
                </div>
              </div>
            </div>
            <div className="home-thq-plan-elm6">
              <div className="home-thq-top-elm6">
                <div className="home-thq-heading-elm18">
                  <span className="home-text215">Plus</span>
                  <span className="home-text216">
                    Sed ut perspiciatis unde omnis iste natus error sit.
                  </span>
                </div>
                <div className="home-thq-cost-elm5">
                  <span className="home-thq-text-elm21">$8</span>
                  <span className="home-thq-text-elm22">/month</span>
                </div>
              </div>
              <div className="home-thq-bottom-elm5">
                <div className="home-thq-check-list-elm6">
                  <Check></Check>
                  <Check feature="Quis nostrud exercitation ulla"></Check>
                  <Check feature="Duis aute irure dolor intuit"></Check>
                  <Check feature="Voluptas sit aspernatur aut odit"></Check>
                  <Check feature="Corporis suscipit laboriosam"></Check>
                </div>
                <div className="home-thq-button-elm7">
                  <span className="home-thq-text-elm23">Get Plus</span>
                </div>
              </div>
            </div>
            <div className="home-thq-plan-elm7">
              <div className="home-thq-top-elm7">
                <div className="home-thq-heading-elm19">
                  <span className="home-text217">Premium</span>
                  <span className="home-text218">
                    Sed ut perspiciatis unde omnis iste natus error sit.
                  </span>
                </div>
                <div className="home-thq-cost-elm6">
                  <span className="home-thq-text-elm24">$16</span>
                  <span className="home-thq-text-elm25">/month</span>
                </div>
              </div>
              <div className="home-thq-bottom-elm6">
                <div className="home-thq-check-list-elm7">
                  <Check></Check>
                  <Check feature="Quis nostrud exercitation ulla"></Check>
                  <Check feature="Duis aute irure dolor intuit"></Check>
                  <Check feature="Voluptas sit aspernatur aut odit"></Check>
                  <Check feature="Corporis suscipit laboriosam"></Check>
                </div>
                <div className="home-thq-button-elm8">
                  <span className="home-thq-text-elm26">Get Plus</span>
                </div>
              </div>
            </div>
            <div className="home-thq-expand-elm2">
              <div className="home-thq-overlay-elm3">
                <div className="home-thq-header-elm4">
                  <div className="home-thq-heading-elm20">
                    <span className="home-text219">Expand</span>
                    <span className="home-text220">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt.
                    </span>
                  </div>
                  <div className="home-thq-check-list-elm8">
                    <div className="home-thq-check-elm4">
                      <svg viewBox="0 0 1024 1024" className="home-icon20">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span className="home-text221">
                        Sed ut perspiciatis unde
                      </span>
                    </div>
                    <div className="home-thq-check-elm5">
                      <svg viewBox="0 0 1024 1024" className="home-icon22">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span className="home-text222">
                        Quis nostrud exercitation ulla
                      </span>
                    </div>
                    <div className="home-thq-check-elm6">
                      <svg viewBox="0 0 1024 1024" className="home-icon24">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span className="home-text223">
                        Duis aute irure dolor intuit
                      </span>
                    </div>
                  </div>
                </div>
                <div className="home-thq-button-elm9">
                  <span className="home-thq-text-elm27">
                    <span>Contact us</span>
                    <br></br>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="home-thq-help-elm">
          <span className="home-text226">Need any help?</span>
          <div className="home-thq-explore-elm3">
            <span className="home-text227">
              Get in touch with us right away -&gt;
            </span>
          </div>
        </div>
      </div>
      <div className="home-thq-testimonials-elm">
        <div className="home-thq-logo-container-elm">
          <img
            alt="pastedImage"
            src="/ro_mini_icon.svg"
            className="home-thq-logo-elm"
          />
        </div>
        <div className="home-thq-content-elm6">
          <div id="quotes" className="home-thq-quotes-elm">
            <div className="quote active-quote">
              <Quote rootClassName="quoteroot-class-name"></Quote>
            </div>
            <div className="quote">
              <Quote
                quote='"Testing these templates is a pleasure."'
                author="Author 2"
                title1="Developer @ Vista La Vista"
                rootClassName="quoteroot-class-name"
              ></Quote>
            </div>
            <div className="quote">
              <Quote
                quote='"Wow, awesome works!'
                title1="Designer @ OhBoy"
                rootClassName="quoteroot-class-name"
              ></Quote>
            </div>
          </div>
          <div className="home-thq-buttons-elm3">
            <div id="quote-before" className="home-thq-left-elm">
              <svg viewBox="0 0 1024 1024" className="home-icon26">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div id="quote-next" className="home-thq-right-elm">
              <svg viewBox="0 0 1024 1024" className="home-icon28">
                <path d="M512 170l342 342-342 342-60-60 238-240h-520v-84h520l-238-240z"></path>
              </svg>
            </div>
          </div>
          <div>
            <div className="home-container36">
              <Script
                html={`<script>
(function() {
  var current = 1;
  var nextButton = document.querySelector("#quote-next");
  var previousButton = document.querySelector("#quote-before");
  var quotes = document.querySelectorAll(".quote");
  if (nextButton && previousButton && quotes.length) {
    nextButton.addEventListener("click", function() {
      quotes.forEach(function(quote) {
        quote.classList.remove("active-quote");
      });
      current = current == quotes.length ? 1 : current + 1;
      quotes[current - 1].classList.add("active-quote");
    });
    previousButton.addEventListener("click", function() {
      quotes.forEach(function(quote) {
        quote.classList.remove("active-quote");
      });
      current = current == 1 ? quotes.length : current - 1;
      quotes[current - 1].classList.add("active-quote");
    });
  }
})();
</script>`}
              ></Script>
            </div>
          </div>
        </div>
      </div>
      <div id="FAQ" className="home-thq-faq-elm">
        <div className="home-thq-content-elm7">
          <div className="home-thq-header-elm5">
            <div className="home-thq-tag-elm2">
              <span className="home-text228">
                <span>FAQ</span>
                <br></br>
              </span>
            </div>
            <div className="home-thq-heading-elm21">
              <h2 className="home-text231">Frequently Asked Questions</h2>
            </div>
          </div>
          <div className="home-thq-rows-elm">
            <div className="home-thq-column-elm1">
              <div className="Question">
                <span className="home-thq-title-elm30">
                  What are the main goals of @Romania?
                </span>
                <span className="home-thq-description-elm14">
                  The main goals of @Romania are to create an internationally
                  recognized Country Brand, to promote Romania as a tourist
                  destination and to develop leading AI-driven tools which
                  democratize how we plan, book and travel.
                </span>
              </div>
              <div className="Question">
                <span className="home-thq-title-elm31">
                  How will @Romania benefit businesses?
                </span>
                <span className="home-thq-description-elm15">
                  <span>
                    @Romania will bring numerous benefits for businesses via the
                    Tourism and Tourism Promotion Platforms; two integral
                    components of our strategy that empower businesses to
                    harness their true revenue potential, efficiently promote
                    their offerings and collaborate with unprecedented ease.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br className="home-text233"></br>
                  <span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </span>
              </div>
              <div className="home-thq-question-elm3 Question">
                <span className="home-thq-title-elm32">
                  How does @Romania plan to democratize tourism?
                </span>
                <span className="home-thq-description-elm16">
                  @Romania will democratize tourism by empowering travelers to
                  regain control of their time, by enabling businesses and
                  creators to easily exchange value and by uniting individuals,
                  enterprises and tourism boards under the banner of promoting
                  Romania’s offerings to the world.
                </span>
              </div>
            </div>
            <div className="home-thq-column-elm2">
              <div className="home-thq-question-elm4 Question">
                <span className="home-thq-title-elm33">
                  What is an Ambassador, what are the benefits and how do I
                  become one?
                </span>
                <span className="home-thq-description-elm17">
                  <span>
                    Ambassadors are the people who wish to create positive
                    change in Romania and support the creation of its Country
                    Brand and help boost its tourism promotion. Ambassadors
                    receive a Signed Certificate of Merit, a bespoke medal
                    crafted by the State Mint, access to elite networking
                    opportunities and much more. See the full list of benefits
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <a
                    href="https://www.romania.org.ro/ambassadors#ambassador"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="home-link24"
                  >
                    here.
                  </a>
                  <span>
                    {' '}
                    To become an Ambassador, get in touch with us via email at
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="home-text237">
                    hi@romania.org.ro
                  </span>
                  <span> or via our social channels.</span>
                </span>
              </div>
              <div className="home-thq-question-elm5 Question">
                <span className="home-thq-title-elm34">
                  How is @Romania different from other non-profits?
                </span>
                <span className="home-thq-description-elm18">
                  Most non-profits operate within a specifically targeted scope,
                  without necessarily expanding their impact beyond donations
                  with a singular effect. @Romania’s initiative for tourism
                  promotion is an economic multiplier with tangible returns that
                  extends beyond the country’s tourism industry and boosts
                  multiple sectors throughout our economy.
                </span>
              </div>
              <div className="home-thq-question-elm6 Question">
                <span className="home-thq-title-elm35">
                  How can I get involved with @Romania&apos;s initiative?
                </span>
                <span className="home-thq-description-elm19">
                  <span>
                    There are many ways to get involved with our initiative. The
                    simplest way would be to follow our journey through our
                    social media channels and keep up with what we’re building.
                    But, if you’re someone who is looking to do more for
                    Romania’s tourism promotion, you can become an Ambassador
                    and have a huge positive impact. Find out more
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <Link to="/ambassadors" className="home-navlink20">
                    here.
                  </Link>
                  <br className="home-text240"></br>
                  <span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="home-container37 container_1600">
        <div className="home-thq-get-started-elm">
          <div className="home-thq-content-elm8">
            <div className="home-thq-heading-elm22">
              <h2 className="home-text242">Explore the Future of Tourism!</h2>
              <span className="home-text243">
                Take control of your travel experiences and help shape the
                future of tourism. Whether you&apos;re a traveler, a tourism
                business owner, or just someone who wants to support a great
                idea, join our community and let’s build!
              </span>
            </div>
            <a
              href="https://www.instagram.com/romania/"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link25"
            >
              <div className="home-thq-fifth-elm">
                <span className="home-thq-caption-elm29">
                  Join our Community
                </span>
              </div>
            </a>
          </div>
          <img
            alt="image"
            src="/assets/asset%2034-200w.png"
            className="home-image18"
          />
          <img
            alt="image"
            src="/assets/asset%2030-200w.png"
            className="home-image19"
          />
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
